  import {
    AUTHENTICATING_MARKETO_REQUEST, AUTHENTICATING_MARKETO_SUCCEDDED, AUTHENTICATING_MARKETO_FAILED
  } from '../actionTypes.jsx';
  import {activatingIntegrationSuccedded } from '../integrations';
  import axios from 'axios';

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const MARKETO_BASE_URL = `${apiUrl}/api/2.0/integrations/marketo`;
  
  export function activateAccount(configuration){
    return function (dispatch) {
      dispatch(activatingAccount());
  
      return axios({
        method: 'POST',
        url: MARKETO_BASE_URL,
        data: configuration
      })
      .then((response) => {
        dispatch(activatingIntegrationSuccedded(response.data));
        return dispatch(activatingAccountSuccedded(response.data));
      })
      .catch((error) => {
        return dispatch(activatingAccountFailed(error));
      })
    }
  }
  
  function activatingAccount(){
    return {
      type: AUTHENTICATING_MARKETO_REQUEST,
      payload: {}
    }
  }
  
  function activatingAccountSuccedded(json){
    return {
      type: AUTHENTICATING_MARKETO_SUCCEDDED,
      payload: json
    }
  }
  
  function activatingAccountFailed(error){
    return {
      type: AUTHENTICATING_MARKETO_FAILED,
      payload: error
    }
  }